"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Chunk = _interopRequireDefault(require("./Chunk"));

var OneColumnContent = function OneColumnContent(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement(_react["default"].Fragment, null, props.columns.columnOne !== null &&
    /*#__PURE__*/
    _react["default"].createElement(_Chunk["default"], {
      chunk: props.columns.columnOne.chunk,
      langKey: props.langKey,
      reusable: props.reusable
    }))
  );
};

var _default = OneColumnContent;
exports["default"] = _default;